import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import Translate from '../common/Translate';
import 'lightbox-react/style.css';

const DisplayAnomaly = ({ id, element, displayValue, handleDeleteBlock, handleUpdateDamage }) => {
  return (
    <Col xs="12" md="6" lg="6" key={id}>
      <Row className="single-damage-image">
        <Col xs="12">
          <div className="damage-text">
            <p className="text-primary h6 damage-text">
              <Translate code={element} />
            </p>
            <span className="text-secondary">{displayValue}</span>
          </div>
          <div>
            <FontAwesomeIcon
              icon={faTimesCircle}
              onClick={() => handleDeleteBlock()}
              className="damage-delete-btn"
              size="2x"
            />
          </div>
        </Col>
      </Row>
      <p
        className="modify-btn text-right"
        onClick={() => handleUpdateDamage(id)}
        onKeyDown={() => {}}
        role="presentation"
      >
        <Translate code="modify" />
      </p>
    </Col>
  );
};

DisplayAnomaly.propTypes = {
  id: PropTypes.string.isRequired,
  element: PropTypes.string.isRequired,
  displayValue: PropTypes.string.isRequired,
  handleDeleteBlock: PropTypes.func.isRequired,
  handleUpdateDamage: PropTypes.func.isRequired,
};

DisplayAnomaly.defaultProps = {};
export default DisplayAnomaly;
